
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3.667a.917.917 0 00-.917.916c0 1.551-1.875 2.328-2.972 1.231a.917.917 0 10-1.297 1.297c1.097 1.097.32 2.972-1.23 2.972a.917.917 0 100 1.834c1.55 0 2.327 1.875 1.23 2.972a.917.917 0 001.297 1.296c1.097-1.096 2.972-.32 2.972 1.232a.917.917 0 001.834 0c0-1.552 1.875-2.329 2.972-1.232a.917.917 0 001.296-1.296c-1.096-1.097-.32-2.972 1.232-2.972a.917.917 0 000-1.834c-1.552 0-2.329-1.875-1.232-2.972a.917.917 0 10-1.296-1.297c-1.097 1.097-2.972.32-2.972-1.23A.917.917 0 0011 3.666zm-2.743.712a2.75 2.75 0 015.485 0 2.75 2.75 0 013.879 3.878 2.75 2.75 0 010 5.485 2.75 2.75 0 01-3.879 3.879 2.75 2.75 0 01-5.485 0 2.75 2.75 0 01-3.878-3.879 2.75 2.75 0 010-5.485A2.75 2.75 0 018.257 4.38z","fill":"#A0AEC0"}}),_c('path',{attrs:{"d":"M11 9.167a1.833 1.833 0 100 3.666 1.833 1.833 0 000-3.666zm-2.593-.76a3.667 3.667 0 115.186 5.186 3.667 3.667 0 01-5.186-5.186z","fill":"#A0AEC0"}})])
          )
        }
      }
    